import React, { useEffect, useState } from "react";
import Image from "next/image";
import LazySection from "../../../components/LazySection";

export default function Common_html({ BlockData }) {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(
        typeof window !== "undefined" ? window.innerWidth > 1199 : false
      );
    };

    handleResize();

    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  return (
    <>
      <div
        className={`common_leftright_pattern_block_mainwrapper common_leftright_pattern_block_mainwrapper_the_persona ${BlockData.chapter_class}`}
      >
        {BlockData.blocks.map((block, index) => (
          <LazySection key={index} className="class_for_padding_bottom">
            <div className="common_leftright_pattern_block_innerwrapper">
              {block.has_heading && (
                <div className="common_leftright_pattern_titleblock">
                  <div className="common_leftright_pattern_titleblock_commonwidth">
                    <span className="common_leftright_pattern_titleblock_inner">
                      <div className="common_leftright_pattern_titleblock_header_wrapper">
                        <h1
                          className="common_leftright_pattern_titleblock_header"
                          dangerouslySetInnerHTML={{
                            __html: block.heading_text,
                          }}
                        ></h1>
                        {block.has_subheading && (
                          <h2
                            className="common_leftright_pattern_titleblock_subheader"
                            dangerouslySetInnerHTML={{
                              __html: block.subheading_text,
                            }}
                          ></h2>
                        )}
                      </div>
                    </span>
                  </div>
                </div>
              )}

              <div
                className={`common_leftright_pattern_block the_persona_leftright_pattern_block${
                  index + 1
                }`}
              >
                <div className="common_leftright_pattern_content_commonwidth">
                  {(() => {
                    const renderContent = (contentItems) => {
                      let renderedElements = [];
                      let paragraphGroup = [];

                      contentItems.forEach((item, itemIndex) => {
                        if (
                          item.type === "paragraph" ||
                          item.type === "bulletpoint_list_blue_square" ||
                          item.type === "gradient_three_cards"
                        ) {
                          if (item.type === "paragraph") {
                            paragraphGroup.push(
                              <p
                                className="common_leftright_pattern_block_paragraph"
                                dangerouslySetInnerHTML={{ __html: item.text }}
                                key={`paragraph-${itemIndex}`}
                              ></p>
                            );
                          } else if (
                            item.type === "bulletpoint_list_blue_square"
                          ) {
                            paragraphGroup.push(
                              <ul
                                className={`common_leftright_pattern_block_bulletpoint_list common_leftright_pattern_block_bulletpoint_list_blue_square common_leftright_pattern_block_bulletpoint_list${itemIndex}`}
                                key={`ul-${itemIndex}`}
                              >
                                {item.persona_yellow_subheading_text && (
                                  <span className="persona_yellow_subheading_text">
                                    {item.persona_yellow_subheading_text}
                                  </span>
                                )}
                                {item.items.map((listItem, liIndex) => (
                                  <li
                                    className={`common_leftright_pattern_block_bulletpoint common_leftright_pattern_block_bulletpoint_ul-${itemIndex}li-${liIndex}`}
                                    key={`li-${itemIndex}-${liIndex}`}
                                    dangerouslySetInnerHTML={{
                                      __html: listItem,
                                    }}
                                  ></li>
                                ))}
                              </ul>
                            );
                          } else if (item.type === "gradient_three_cards") {
                            paragraphGroup.push(
                              <div className="gradient_three_cards_outerwrapper">
                                {item.persona_yellow_subheading_text && (
                                  <span className="persona_yellow_subheading_text">
                                    {item.persona_yellow_subheading_text}
                                  </span>
                                )}
                                <div className="gradient_three_cards_wrapper">
                                  {item.cards &&
                                    item.cards.map((card, cardIndex) => (
                                      <div
                                        className={`gradient_three_cards_item gradient_three_cards_item-${
                                          cardIndex + 1
                                        }`}
                                        key={cardIndex}
                                      >
                                        <p>{card.text}</p>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            );
                          }
                        } else {
                          if (paragraphGroup.length > 0) {
                            renderedElements.push(
                              <div
                                className="common_leftright_pattern_block_paragraph_wrapper"
                                key={`paragraph-group-${renderedElements.length}`}
                              >
                                {paragraphGroup}
                              </div>
                            );
                            paragraphGroup = [];
                          }
                        }
                      });

                      if (paragraphGroup.length > 0) {
                        renderedElements.push(
                          <div
                            className="common_leftright_pattern_block_paragraph_wrapper"
                            key={`paragraph-group-final`}
                          >
                            {paragraphGroup}
                          </div>
                        );
                      }
                      return renderedElements;
                    };

                    let imageUrl = "";
                    if (block.type == "position_bothsides") {
                      imageUrl = isDesktop
                        ? block.block_positioned_image_url_desktop
                        : block.block_positioned_image_url_mobile;
                    }

                    switch (block.type) {
                      case "position_bothsides":
                        return (
                          <div
                            className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_${
                              index % 2 === 0 ? "left" : "right"
                            }`}
                          >
                            {imageUrl &&
                              typeof imageUrl === "string" &&
                              imageUrl.length > 0 && (
                                <div className="common_leftright_pattern_block_position_image_wrapper">
                                  <Image
                                    className="next_image"
                                    src={imageUrl}
                                    alt="Block Content"
                                    width={1200}
                                    height={800}
                                  />
                                </div>
                              )}

                            {block.content && (
                              <div className="common_leftright_pattern_block_content">
                                {renderContent(block.content)}
                              </div>
                            )}
                          </div>
                        );

                      case "gradient_three_cards":
                        return (
                          <div className="gradient_three_cards_wrapper">
                            {block.cards &&
                              block.cards.map((card, cardIndex) => (
                                <div
                                  className={`gradient_three_cards_item gradient_three_cards_item-${
                                    cardIndex + 1
                                  }`}
                                  key={cardIndex}
                                >
                                  <p>{card.text}</p>
                                </div>
                              ))}
                          </div>
                        );

                      default:
                        return (
                          <div
                            className={`common_leftright_pattern_block_inner_wrapper common_leftright_pattern_block_position_image_${
                              (index + 1) % 2 === 0 ? "left" : "right"
                            }`}
                          >
                            {block.content && (
                              <div className="common_leftright_pattern_block_content">
                                {renderContent(block.content)}
                              </div>
                            )}
                          </div>
                        );
                    }
                  })()}
                </div>
              </div>
            </div>
          </LazySection>
        ))}
      </div>
    </>
  );
}
